import { messageStop } from "@/api/llm";
import React, { useContext, useCallback, useEffect, useMemo, useState } from "react";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import { connect } from "dva";
import ChatState, { LLMMessageStatus } from "@/types/chat/State";
import Context from "@/components/chat/context";
import QuestionOperation from "@/baseComponents/Chat/QuestionOperation";

function mapDispatchToProps(dispatch: any) {
  return {
    dealStopQuestions(data: any) {
      dispatch({ type: "chat/dealStopQuestions", payload: data });
    }
  };
}

function mapStateToProps({ chat }: { user: any; chat: ChatState }) {
  return {
    selectedSession: chat.selectedSession,
    sessionMessageMap: chat.sessionMessageMap
  };
}

// 问题操作区
function QuestionAction(props: any) {
  const { lastAIMessage } = useContext(Context);
  const { dealStopQuestions } = props;

  const isAIInputDisable = useMemo(() => {
    if (!lastAIMessage) {
      return false;
    }
    return lastAIMessage?.flag !== "end" && !lastAIMessage?.isMyself;
  }, [lastAIMessage]);

  // 结束问答
  const handleStopQuestion = useCallback(() => {
    if (isAIInputDisable) {
      return;
    }
    dealStopQuestions({
      id: lastAIMessage?.id || "",
      nextChat: true
    });
  }, [dealStopQuestions, isAIInputDisable, lastAIMessage?.id]);

  return !isAIInputDisable ? (
    <div className={styles["question-action-wrap"]}>
      <div
        className={`${styles["item"]} ${isAIInputDisable ? styles["disable"] : ""}`}
        onClick={handleStopQuestion}
      >
        <IconFont className={styles["icon"]} type="iconxinhuihua" />
        <span className={styles["text"]}>开启新会话</span>
      </div>
    </div>
  ) : lastAIMessage?.flag === LLMMessageStatus.PENDING ? (
    <QuestionOperation message={lastAIMessage} className="smallAI" />
  ) : null;
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionAction);
